import { defineManifest } from '@ndrc/app-sdk/manifest';
import { emitsOf } from '@ndrc/app-sdk/events';
import { events } from './events.js';
import fr from './messages/fr.json' with { type: 'json' };
export const manifest = defineManifest({
  id: 'seo_lab',
  name: fr.title,
  description: fr.description,
  icon: 'grid',
  color: '#1D4ED8',
  glyph: [{ d: 'M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14z' }, { d: 'M15 15l6 6M7 10h6M10 7v6' }],
  version: '0.1.0',
  sdk: '0.0.0',
  status: 'dev',
  category: 'relation-client',
  permissions: {
    uses: ['app.records.read', 'app.records.write', 'external.productions.read'],
    defines: [],
  },
  entities: {
    uses: [],
    owns: ['assignments', 'snapshots', 'comparisons', 'receipts'].map((table) => ({
      table,
      scope: 'workspace' as const,
      description: fr.description,
    })),
  },
  events: {
    emits: emitsOf(events),
    subscribes: [],
  },
  ui: {
    student: { defaultRoute: '/', routes: [{ path: '/', title: fr.title }], layout: 'full' },
    teacher: { panel: true, widgets: [], studentInspector: true },
  },
  missions: { actions: ['seo_lab.seed'], conditions: ['seo_lab.completed'], blocks: [] },
  migrations: { schema: 'app_seo_lab', dir: 'migrations' },
});
